import actionsMutations from "./actions.mutation";
import actionsStates from "./actions.state";
import actionsActions from "./actions.action";
import actionsGetters from "./actions.getters";

export default {
  mutations: actionsMutations,
  state: actionsStates,
  actions: actionsActions,
  getters: actionsGetters
};
